import * as Yup from 'yup'

export const EditContractorFileNameSchema = Yup.object().shape({
  name: Yup.string().required('This field is required'),
})
